import React, { useCallback, useContext, useEffect } from 'react'
import { DraftTextStyles } from './Style'
import { TextareaAutosize } from '@mui/material'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { change } from 'redux-form'
import { Button, UploadFile } from 'components/Form'
import { categories } from 'keys'
import { CreateAssessmentDefContext } from './CreateAssessmentDefContext'
import mammoth from "mammoth"
import GraphemeSplitter from 'grapheme-splitter';

const DraftText = () => {
    const { categoryItem, grade } = useContext(CreateAssessmentDefContext)
    const formValues = useSelector(state => state.form.createAssessmentDef?.values)
    const dispatch = useDispatch()

    const { rowCount = 3, columnCount = 3 } = grade || {}
    const numWords = rowCount * columnCount

    const updateTextDraft = useCallback((e) => {
        dispatch(change('createAssessmentDef', 'text_draft', e.target.value))
    }, [])

    const updateText = useCallback(async (file) => {
        dispatch(change('createAssessmentDef', 'file', file))
        const arrayBuffer = await file.arrayBuffer();
        const { value: text } = await mammoth.extractRawText({ arrayBuffer });
        dispatch(change('createAssessmentDef', 'text_draft', text));
        if (categoryItem.name == categories.REAL_WORDS) {
            let words = text.trim().split(/[\s]+/).filter(Boolean)
            if (words.length % numWords) {
                words = [...words, ...new Array(numWords - (words.length % numWords)).fill("")];
            }
            dispatch(change('createAssessmentDef', 'words', words));
        }
        if (categoryItem.name == categories.LETTER_SOUNDS || categoryItem.name == categories.LETTER_NAMING) {
            const splitter = new GraphemeSplitter();
            let letters = splitter.splitGraphemes(text.replace(/[ \t\r\n]+/g, ''));
            if (letters.length % 9) {
                letters = [...letters, ...new Array(9 - (letters.length % 9)).fill("")];
            }
            dispatch(change('createAssessmentDef', 'words', letters));
        }
    }, [categoryItem])

    const cleanFile = useCallback(() => {
        dispatch(change('createAssessmentDef', 'upload_file', null));
        dispatch(change('createAssessmentDef', 'text_draft', ""));
        const nArray = new Array(numWords).fill("")
        dispatch(change('createAssessmentDef', 'words', nArray));
    }, [])

    return (
        <DraftTextStyles>
            <div className="upload-actions">
                <div className='upload-file'>
                    <UploadFile
                        size="small"
                        name="upload_file"
                        input={{
                            value: "",
                            onChange: updateText,
                        }}
                        type="docx"
                    />
                </div>
                <Button
                    color="dark"
                    label="ניקוי"
                    action={cleanFile}
                />
            </div>
            <TextareaAutosize
                name="text_draft"
                dir="ltr"
                value={formValues.text_draft || ""}
                placeholder={"הדבקת טקסט כאן"}
                onChange={updateTextDraft}
            />
        </DraftTextStyles>
    )

}

export default DraftText